import { Device, Facility, FacilityGroup, TrafficReportConfiguration } from "@app/shared";
import { ChartSizeProps } from "../shared/charts";

export type TrafficReportContext = { device?: Device, facility?: Facility, facilityGroup?: FacilityGroup };
export type TrafficReportProps = { size: ChartSizeProps, title?: string | ((data: any) => string), subTitle?: string | ((data: any) => string) };

export enum DateOptions {
    AllData = "All Data",
    ThisYear = "This Year",
    ThisMonth = "This Month",
    ThisWeek = "This Week",
    LastYear = "Last Year",
    Last90Days = "Last 90 Days",
    LastMonth = "Last Month",
    LastWeek = "Last Week",
    Custom = "Custom"

}
export interface IConfiguredTrafficReport {
    component: React.FC<TrafficReportProps>,
    name: string,
    key: string,
    description: string;
    defaultChartType: 'line' | 'bar' | 'other',
    defaultRange: DateOptions,
    downloadData?: (args: TrafficReportConfiguration) => void,
    config?: {
        allowsCustomRange?: boolean;
        allowsIgnoreStoppedTraffic?: boolean;
        disallowChartTypeToggling?: boolean;
        requiresMonth?: boolean;
        requiresYear?: boolean;
        allowTargetTypeGrouping: boolean;
        hideDeviceSelection?: boolean;
        disabled?: boolean;
        maxDaysRange?: number; 
    }
}